import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { Music2 } from "lucide-react";

const NAV = [
    { to: "/tanpura", label: "Tanpura", testid: "nav-tanpura" },
    { to: "/taals", label: "Taals", testid: "nav-taals" },
    { to: "/metronome", label: "Metronome", testid: "nav-metronome" },
    { to: "/scale-finder", label: "Scale Studio", testid: "nav-scale" },
    { to: "/tuner", label: "Tuner", testid: "nav-tuner" },
	{ to: "/practice-track", label: "Practice Track", testid: "nav-practice-track",},
	
];

export default function Layout() {
    const loc = useLocation();
    const isHome = loc.pathname === "/";
    return (
        <div className="min-h-screen flex flex-col">
            <header
                data-testid="site-header"
                className="sticky top-0 z-40 backdrop-blur-xl bg-background/70 border-b border-border/60"
            >
                <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
                    <Link
                        to="/"
                        data-testid="site-logo"
                        className="flex items-center gap-2 group"
                    >
                        <span className="w-8 h-8 rounded-md grid place-items-center bg-primary text-primary-foreground">
                            <Music2 size={16} strokeWidth={2.2} />
                        </span>
                        <span className="font-sans font-extrabold text-2xl tracking-tight leading-none">
                            Kundan <span className="text-primary">Flutes</span>
                        </span>
                    </Link>
                    <nav className="hidden md:flex items-center gap-1">
                        {NAV.map((n) => (
                            <NavLink
                                key={n.to}
                                to={n.to}
                                data-testid={n.testid}
                                className={({ isActive }) =>
                                    `px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                                        isActive
                                            ? "bg-secondary text-foreground"
                                            : "text-muted-foreground hover:text-foreground hover:bg-secondary/60"
                                    }`
                                }
                            >
                                {n.label}
                            </NavLink>
                        ))}
                    </nav>
                </div>
                {/* Mobile nav */}
                <div className="md:hidden border-t border-border/60">
                    <div className="max-w-7xl mx-auto px-4 flex overflow-x-auto gap-1 py-2">
                        {NAV.map((n) => (
                            <NavLink
                                key={n.to}
                                to={n.to}
                                data-testid={`${n.testid}-mobile`}
                                className={({ isActive }) =>
                                    `px-3 py-1.5 rounded-md text-xs font-medium whitespace-nowrap ${
                                        isActive
                                            ? "bg-secondary text-foreground"
                                            : "text-muted-foreground"
                                    }`
                                }
                            >
                                {n.label}
                            </NavLink>
                        ))}
                    </div>
                </div>
            </header>

            <main className={isHome ? "" : "max-w-7xl mx-auto w-full px-6 lg:px-10 py-10 lg:py-16 flex-1"}>
                <Outlet />
            </main>

            <footer className="border-t border-border/60 mt-20">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 grid sm:grid-cols-3 gap-8 text-sm text-muted-foreground">
                    <div>

    <Link
        to="/"
        className="flex items-center gap-3 mb-4"
    >

        <span className="w-10 h-10 rounded-md grid place-items-center bg-primary text-primary-foreground">

            <Music2
                size={20}
                strokeWidth={2.2}
            />

        </span>

        <span className="font-sans font-extrabold text-2xl tracking-tight text-foreground">

            Kundan <span className="text-primary">Flutes</span>

        </span>

    </Link>

    <p className="text-muted-foreground/80 leading-relaxed">

        A free, modern practice room for Hindustani musicians —
        tanpura, tabla, metronome and a precision flute tuner,
        all in your browser.

    </p>

</div>
                    <div>
                        <div className="text-foreground font-medium mb-2">
                            Practice Tools
                        </div>
                        <ul className="space-y-1">
                            {NAV.map((n) => (
                                <li key={n.to}>
                                    <Link
                                        to={n.to}
                                        className="hover:text-foreground"
                                    >
                                        {n.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <div className="text-foreground font-medium mb-2">
                            Practice Tips
                        </div>
                        <p>
                            For the best experience, use headphones while practicing. Allow microphone access when using the flute tuner.
                        </p>
                    </div>
                </div>
                <div className="text-center text-xs text-muted-foreground/70 pb-6">
                    © {new Date().getFullYear()} Kundan Flutes • Crafted with ❤️ for Indian Classical Musicians
					| Have feedback or feature suggestions?
📧 kundanflutes@gmail.com
                </div>
            </footer>
        </div>
    );
}
